import { useSearchParams } from 'react-router-dom';

const GROUP_BY_GUIDS = 'groupByGuids';

/** Query param holding the selected account GUIDs, e.g. to carry the selection across reporting tabs. */
export const REPORTING_ACCOUNTS_SEARCH_PARAMS = [GROUP_BY_GUIDS] as const;

export const readSelectedAccountGUIDs = (params: URLSearchParams): string[] => {
    const raw = params.get(GROUP_BY_GUIDS);
    return raw ? raw.split(',').filter(Boolean) : [];
};

/**
 * Writes the selection into `params` in place. An empty selection means the whole-household total
 * and is represented by omitting the param, keeping the URL clean. Exposed so a caller changing
 * several reporting filters at once can compose them into a single URL update.
 */
export const applySelectedAccountGUIDs = (params: URLSearchParams, accountGUIDs: string[]): URLSearchParams => {
    if (accountGUIDs.length) {
        params.set(GROUP_BY_GUIDS, accountGUIDs.join(','));
    } else {
        params.delete(GROUP_BY_GUIDS);
    }
    return params;
};

/**
 * Reads the selected account GUIDs from the `groupByGuids` query param (comma-separated),
 * scoping the performance cards and chart. Mirrors the reporting API's `groupByGuids` parameter.
 * ReportingAccountSelector writes it, together with the closed-account toggle.
 */
export const useReportingAccounts = (): { selectedAccountGUIDs: string[] } => {
    const [params] = useSearchParams();
    return { selectedAccountGUIDs: readSelectedAccountGUIDs(params) };
};
